import { render } from "./ui-modals.vue?vue&type=template&id=5af9acff"
import script from "./ui-modals.vue?vue&type=script&lang=js"
export * from "./ui-modals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__